import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { SkeletonRegion, useStableKeys } from './_shared'

export interface ListSkeletonProps {
	count?: number
	itemHeight?: string
	gap?: string
	withAvatar?: boolean
	className?: string
	label?: string | false
}

export function ListSkeleton({
	count = 4,
	itemHeight = 'h-9',
	gap = 'gap-1',
	withAvatar = false,
	className,
	label = 'Loading',
}: ListSkeletonProps) {
	const keys = useStableKeys(count)
	return (
		<SkeletonRegion label={label} className={cn('flex flex-col', gap, className)}>
			{keys.map(key => (
				<div key={key} className={cn('flex items-center gap-2', itemHeight)}>
					{withAvatar ? <Skeleton className='size-6 shrink-0 rounded-full' /> : null}
					<Skeleton className='h-4 w-full' />
				</div>
			))}
		</SkeletonRegion>
	)
}
